if (!customElements.get('wr-facets-sort-select')) {
    customElements.define(
      'wr-facets-sort-select',
      class wrFacetsSortSelect extends HTMLElement {
        constructor() {
          super();
          this.select = this.querySelector('#sort-by-select');
        }
  
        connectedCallback() {
          this.select.addEventListener('change', this.onChangeSelect.bind(this));
        }
  
        onChangeSelect(e) {
            e.preventDefault();
            const sortOption = document.querySelector(`.popover-listbox__option[value="${e.target.value}"]`);
            sortOption?.click();
        }
      }
    );
  }
  